<template>
  <!--该页面内容高度为父容器的100%，不允许出现垂直方向的滚动条-->
  <div class="min-live-video">
      <div class="video-list">
        <div class="video-item"
             v-for="(item, index) in players"
             :class="[isSingle ? 'single-video-item' : '', item.id === currentVideoPlayerId ? '' : '']"
             v-show="!isSingle || (isSingle && (currentVideoPlayerId !== 0 && item.id === currentVideoPlayerId) || (currentVideoPlayerId === 0 && index === 0)) "
             :key="'videoItem' + index"
             ref="videoItem"
        >
          <div class="video-item-title" :class="$globalConfig.playerTitleStyleForMinLiveVideo === 0 ? '':'dark-blue-style'" v-show="tileVisible">
            <div class="video-item-title-left">{{ item.active ? item.streamNodeName : item.title }}</div>
            <div class="video-item-title-right">
              <a @click="capturePictureJpeg()" href="javascript:;" class="video-item-btn camera-btn"></a>
              <!--<a href="javascript:;" class="video-item-btn save-btn"></a>-->
              <a @click="stopVideo(item.streamNodeId)" href="javascript:;" class="video-item-btn close-btn"></a>
            </div>
          </div>
          <div class="video-item-content" :class="[tileVisible ? '':'video-item-title-hide',$globalConfig.playerBackgroundStyleForMinLiveVideo === 0 ? '':'black-style']" ref="videoPlayerContainer">
            <!--视频控件-->
            <video :id="'video-player' + String(index + 1)" ref="videoPlayer" class="video-player" v-show="item.active" controls autplayerParamslay></video>
          </div>
        </div>
      </div>
  </div>
</template>

<script type="text/ecmascript-6">
import MinLiveVideo from './MinLiveVideo.js'
export default MinLiveVideo
</script>

<style lang="scss">
@import "MinLiveVideo";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/minLiveVideo/MinLiveVideo.vue